import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

import {
  ITDSBalances,
  ITDSPayment,
  ITDSBalancesParams,
  ITDSPaymentForm,
  ITDSPaymentHistoryParams,
  ITDSBalancesResponse,
  ITDSPaymentResponse,
  ITDSPaymentHistoryResponse,
  ITDSTransactionBreakdown,
  ITDSTransactionBreakdownResponse
} from "../../utils/tdsSettlement.types";

/**
 * Fetch TDS balances for a period
 */
export const fetchTDSBalances = createAsyncThunk(
  'tdsSettlement/fetchBalances',
  async (params: ITDSBalancesParams): Promise<ITDSBalances> => {
    const response = await axios.get<ITDSBalancesResponse>(
      `/api/v1/tds-settlement/balances`,
      { params }
    );
    return response.data.data;
  }
);

/**
 * Record TDS payment to government
 */
export const recordTDSPayment = createAsyncThunk(
  'tdsSettlement/recordPayment',
  async (paymentData: ITDSPaymentForm): Promise<ITDSPayment> => {
    const response = await axios.post<ITDSPaymentResponse>(
      `/api/v1/tds-settlement/payment`,
      paymentData
    );
    return response.data.data;
  }
);

/**
 * Fetch TDS payment history
 */
export const fetchTDSPaymentHistory = createAsyncThunk(
  'tdsSettlement/fetchHistory',
  async (params?: ITDSPaymentHistoryParams): Promise<ITDSPayment[]> => {
    const response = await axios.get<ITDSPaymentHistoryResponse>(
      `/api/v1/tds-settlement/payment-history`,
      { params }
    );
    return response.data.data;
  }
);

/**
 * Fetch single TDS payment by ID
 */
export const fetchTDSPaymentById = createAsyncThunk(
  'tdsSettlement/fetchPaymentById',
  async (paymentId: string): Promise<ITDSPayment> => {
    const response = await axios.get<ITDSPaymentResponse>(
      `/api/v1/tds-settlement/payment/${paymentId}`
    );
    return response.data.data;
  }
);

/**
 * Fetch TDS transaction breakdown
 * Shows detailed list of all invoices and payments that contributed to TDS amounts
 */
export const fetchTDSTransactionBreakdown = createAsyncThunk(
  'tdsSettlement/fetchTransactionBreakdown',
  async (params: ITDSBalancesParams): Promise<ITDSTransactionBreakdown> => {
    const response = await axios.get<ITDSTransactionBreakdownResponse>(
      `/api/v1/tds-settlement/transactions`,
      { params }
    );
    return response.data.data;
  }
);
